import { render, staticRenderFns } from "./TimeSlice.vue?vue&type=template&id=4fb5ce66&"
import script from "./TimeSlice.vue?vue&type=script&lang=js&"
export * from "./TimeSlice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports